export default __webpack_public_path__ + "static/media/Mystic's Gloves of the Eldritch.9cb575fe.jpg";